import { Injectable } from '@angular/core'
import { ApiClientService } from '../service/api-client.service'
import { environment } from '../../environments/environment'
import { DatePipe } from '@angular/common'
import 'rxjs/add/operator/map'
import * as FileSaver from 'file-saver'
import { isNullOrUndefined } from 'util'
import { StoreService } from './store.service'

@Injectable()
export class CpmService {
  listMarketP
  listMarketPerformanceTable = []
  lastTradingDate
  securityProfile
  constructor(
    private apiClient: ApiClientService,
    private datePipe: DatePipe,
    private store: StoreService
  ) {}

  async getMarketStatisticByYear(indexName, startYear, endYear) {
    const path = `${
      environment.cpmBaseUrl
    }/marketStatistic/byYear?indexName=${indexName.toString()}&startYear=${startYear}&endYear=${endYear}`

    return this.apiClient.getWithPath(path).toPromise()
  }

  getMarketPerformanceByYear(indexName, startYear, endYear) {
    const path = `${
      environment.cpmBaseUrl
    }/mktPerformance/byYear?indexName=${indexName.toString()}&startYear=${startYear}&endYear=${endYear}`

    return this.apiClient.getWithPath(path)
  }

  getMarketPerformanceByPeriod(indexName, startDate, endDate) {
    const path = `${
      environment.cpmBaseUrl
    }/mktPerformance/byPeriod?indexName=${indexName}&startDate=${startDate}-01-01&endDate=${endDate}`

    return this.apiClient.getWithPath(path)
  }

  async getMarketPeriod(indexName, startDate, endDate) {
    await this.getLastTradingDate();
    const date = this.datePipe.transform(new Date(this.lastTradingDate.lastTradingDate), 'yyyy-MM-dd')
    const xx = indexName.map(objx => {
      return this.getMarketPerformanceByPeriod(objx.toString(), startDate, date)
        .toPromise()
        .then(d => {
          return Promise.resolve(
            d.map(x => {
              x.indexClose.toFixed(2),
                x.pe.toFixed(2),
                (x.marketCap = (x.marketCap / 1000000).toFixed(2))
              return x
            })
          )
        })
    })

    return Promise.all(xx).then(result => {
      const res = []
      const r = result.map(d => {
        const gg = Object.keys(d).map(k => res.push(d[k]))
      })
      return Promise.resolve(res)
    })
  }

  async getMarketPerformance(year, indexName) {
    this.listMarketP = []
    await this.getLastTradingDate();
    const nyear = new Date(this.lastTradingDate.lastTradingDate).getFullYear()
    const xx =
      year === 0
        ? indexName.map(obj => {
            return this.getMarketPerformanceByYear(obj.toString(), nyear, nyear)
              .toPromise()
              .then(d => {
                return Promise.resolve(
                  d.marketStatistics.map(x => {
                    const mStatistics = {
                      year: x.year,
                      indexName: x.indexName,
                      indexClose: x.indexClose.toFixed(2),
                      pe: x.pe.toFixed(2),
                      marketCap: (x.marketCap / 1000000).toFixed(2),
                      indexChange: (() => {
                        const receivedData =
                          d.marketTradingStatistic.indexChangeD1
                        return receivedData !== null
                          ? receivedData.toFixed(2)
                          : '-'
                      })(),
                      indexChangeYTD: (() => {
                        const receivedData =
                          d.marketTradingStatistic.indexChangeYTD
                        return receivedData !== null
                          ? receivedData.toFixed(2)
                          : '-'
                      })(),
                      avgTradingValue: (
                        d.marketTradingStatistic.avgTrading / 1000000
                      ).toFixed(2)
                    }
                    return mStatistics
                  })
                )
              })
          })
        : indexName.map(obj => {
            console.log('XXX - ', nyear - year, nyear)
            return this.getMarketPerformanceByYear(
              obj.toString(),
              nyear - year,
              nyear
            )
              .toPromise()
              .then(d => {
                return Promise.resolve(
                  d.marketStatistics.map(x => {
                    const mStatistics = {
                      year: x.year,
                      indexName: x.indexName,
                      indexClose: x.indexClose.toFixed(2),
                      pe: x.pe.toFixed(2),
                      marketCap: (x.marketCap / 1000000).toFixed(2),
                      indexChange: (() => {
                        const receivedData =
                          d.marketTradingStatistic.indexChangeD1
                        return receivedData !== null
                          ? receivedData.toFixed(2)
                          : '-'
                      })(),
                      indexChangeYTD: (() => {
                        const receivedData =
                          d.marketTradingStatistic.indexChangeYTD
                        return receivedData !== null
                          ? receivedData.toFixed(2)
                          : '-'
                      })(),
                      avgTradingValue: (
                        d.marketTradingStatistic.avgTrading / 1000000
                      ).toFixed(2)
                    }
                    return mStatistics
                  })
                )
              })
          })

    return Promise.all(xx).then(result => {
      const res = []
      const r = result.map(d => {
        const gg = Object.keys(d).map(k => res.push(d[k]))
      })
      return Promise.resolve(res)
    })
  }

  async getLastTradingDate() {
    if (!!this.lastTradingDate) {
      return new Promise((resolve, reject) => {
        resolve(this.lastTradingDate)
      })
    }
    const path = `${environment.cpmBaseUrl}/calendar/lastTradingDate`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        this.lastTradingDate = res
        return Promise.resolve(res)
      })
  }

  async getShareholderInformation(firstname: string, lastname: string) {
    const encodedFirstName: string = encodeURIComponent(firstname)
    const encodedLastName: string = encodeURIComponent(lastname)
    const path = `${
      environment.cpmBaseUrl
    }/shareholderProfile?firstName=${encodedFirstName}&lastName=${encodedLastName}`
    return this.apiClient.getWithPath(path).toPromise()
  }

  async getBodInformation(boardId: string) {
    const path = `${environment.cpmBaseUrl}/bodProfile?boardId=${boardId}`
    return this.apiClient.getWithPath(path).toPromise()
  }

  // Api for Capital-Raised-Ipo-So

  getCapitalRaisediposo(capitalType, startYear, endYear) {
    const path = `${
      environment.cpmBaseUrl
    }/capitalRaised?capitalType=${capitalType}&startYear=${startYear}&endYear=${endYear}`

    return this.apiClient.getWithPath(path)
  }

  // Api for Capital-Raised-Instrument

  getCapitaValueIPO(capitalType, startYear, endYear) {
    const path = `${
      environment.cpmBaseUrl
    }/capitalRaised/byCompType?capitalType=${capitalType}&startYear=${startYear}&endYear=${endYear}`
    return this.apiClient.getWithPath(path)
  }

  getCapitalValueSO(capitalType, startYear, endYear) {
    const path = `${
      environment.cpmBaseUrl
    }/capitalRaised/byCAType?capitalType=${capitalType}&startYear=${startYear}&endYear=${endYear}`
    return this.apiClient.getWithPath(path)
  }
  // Api for Market-Level-Watch-List
  getMarketLevelWatchList(sortBy) {
    const path = `${environment.cpmBaseUrl}/signPosting?sort=${sortBy}`
    return this.apiClient.getWithPath(path)
  }

  async saveMarketCapPeRankPdfFile() {
    const path = `${environment.cpmBaseUrl}/savePdf/marketCapPeRank`
    return this.apiClient.getTextWithPath(path).toPromise()
  }

  async saveMarketCapSecurityRankPdfFile(topRank, checkedIds) {
    const path = `${
      environment.cpmBaseUrl
    }/savePdf/marketCapSecurityRank?topRank=${topRank}&checkedIndustries=${checkedIds}`
    return this.apiClient.getTextWithPath(path).toPromise()
  }

  async saveGlobalIndexMemberPdfFile(type) {
    const path = `${
      environment.cpmBaseUrl
    }/savePdf/globalIndexComposition?indexType=${type}`
    return this.apiClient.getTextWithPath(path).toPromise()
  }

  // Save Pdf for Market Performance PDF
  async saveMarketPerformancePdfFile(ytd) {
    const path = `${
      environment.cpmBaseUrl
    }/savePdf/marketPerformance?ytd=${ytd}`
    return this.apiClient.getTextWithPath(path).toPromise()
  }
  async savecapitaRaisedInstrument(currentItem, currentItem2) {
    const path = `${
      environment.cpmBaseUrl
    }/savePdf/capitalRaisedInstrument?type=${currentItem2}&groupType=${currentItem}`
    return this.apiClient.getTextWithPath(path).toPromise()
  }

  async saveCapitaliposoPdfFile(currentItemCapRaised) {
    const path = `${
      environment.cpmBaseUrl
    }/savePdf/capitalRaisedIpo?type=${currentItemCapRaised}`
    return this.apiClient.getTextWithPath(path).toPromise()
  }

  async getListedSecuritiesByType(year) {
    const path = `${
      environment.cpmBaseUrl
    }/listedCompany/countByType?year=${year}&type=ALL`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  async getIPOSecuritiesByType(year) {
    const path = `${
      environment.cpmBaseUrl
    }/listedCompany/countByType?year=${year}&type=IPO`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }


  async getListedSecuritiesByYear(startYear, endYear) {
    const path = `${
      environment.cpmBaseUrl
    }/listedCompany/countByYear?startYear=${startYear}&endYear=${endYear}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  async getNewIpoByYear(startYear, endYear) {
    const path = `${
      environment.cpmBaseUrl
    }/listedCompany/countIPOByYear?startYear=${startYear}&endYear=${endYear}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  async saveMarketWatchListPdfFile(currentItem) {
    const path = `${
      environment.cpmBaseUrl
    }/savePdf/marketWatchList?sort=${currentItem}`
    return this.apiClient.getTextWithPath(path).toPromise()
  }

  async getExchangeStatisticByIndustry() {
    const path = `${environment.cpmBaseUrl}/exchangeStatistic/byIndustry`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  async getGlobalIndexMember(indexType, asOfDate, round) {
    const date = this.datePipe.transform(asOfDate, 'yyyy-MM-dd')
    const path = `${
      environment.cpmBaseUrl
    }/globalIndexCompositionList?type=${indexType}&asOfDate=${date}&round=${round}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  async getExchangeMacro() {
    const path = `${environment.cpmBaseUrl}/exchangeMacro`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  // get top market cap exchange
  async getExchangeTopMarketCap(rank, industries) {
    const type = rank === 3 ? 'ALL' : ''
    // to prevent arbitrary rank selection
    const path = `${
      environment.cpmBaseUrl
    }/exchangeTopMarketCap?type=${type}&rank=${rank}&industries=${encodeURIComponent(
      industries
    )}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  async getExchangeNetProfit() {
    const path = `${environment.cpmBaseUrl}/exchangeNetProfit`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  // get industies market statistic
  async getExchangeStatistic() {
    // fetch industries market cap
    const path = `${environment.cpmBaseUrl}/exchangeStatistic/byIndustry`
    const responseData = await this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
      .then(res => {
        const totalMarketCapMapping = new Map()
        res.exchangeStatistic.forEach(element => {
          const tempTotalMarketCapMapping = new Map()
          element.industry.forEach(elementIn => {
            const industry = elementIn.industryName
            const marketCap = elementIn.marketCap
            const noOfCompany = elementIn.noOfCompany
            const mappingOfMarketCapAndNoOfCompany = new Map()
            mappingOfMarketCapAndNoOfCompany.set('marketCap', marketCap)
            mappingOfMarketCapAndNoOfCompany.set('noOfCompany', noOfCompany)
            tempTotalMarketCapMapping.set(
              industry,
              mappingOfMarketCapAndNoOfCompany
            )
          })
          totalMarketCapMapping.set(element.country, tempTotalMarketCapMapping)
        })
        return totalMarketCapMapping
      })
    return responseData
  }

  async getExchangeTopIpo(type, rank) {
    const path = `${
      environment.cpmBaseUrl
    }/exchangeTopIPO?type=${type}&rank=${10}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  async getExchangeIpo(type, round) {
    const path = `${
      environment.cpmBaseUrl
    }/exchangeIPO?type=${type}&round=${round}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }
  async getExchangeIpoin5year(type, round) {
    const path = `${
      environment.cpmBaseUrl
    }/exchangeIPO?type=${type}&round=${round}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }
  async saveipoExchangeIn5Year(currentItem) {
    const path = `${
      environment.cpmBaseUrl
    }/savePdf/ipoExchangeIn5Year?type=${currentItem}`
    return this.apiClient.getTextWithPath(path).toPromise()
  }

  async saveExchangeTopIpoPdfFile(ipoValue) {
    const path = `${
      environment.cpmBaseUrl
    }/savePdf/initalPublicofferingTop10?ipoValue=${ipoValue}`
    return this.apiClient.getTextWithPath(path).toPromise()
  }

  async saveFinancialHilightPdfFile(symbol) {
    const endcodeSymbol = encodeURIComponent(symbol)
    const path = `${environment.cpmBaseUrl}/savePdf/financial?symbol=${endcodeSymbol}`
    return this.apiClient.getTextWithPath(path).toPromise()
  }

  async saveMacroDataEconPdfFile() {
    const path = `${environment.cpmBaseUrl}/savePdf/marcroData`
    return this.apiClient.getTextWithPath(path).toPromise()
  }

  async saveHistoricalIndiesPdfFile(marketValue) {
    const path = `${
      environment.cpmBaseUrl
    }/savePdf/historicalIndices?marketValue=${marketValue}`
    return this.apiClient.getTextWithPath(path).toPromise()
  }

  async saveNewAndExistingListedPdfFile() {
    const path = `${environment.cpmBaseUrl}/savePdf/existingListedSecurities`
    return this.apiClient.getTextWithPath(path).toPromise()
  }

  async saveProfitDataPdfFile() {
    const path = `${environment.cpmBaseUrl}/savePdf/profitdata`
    return this.apiClient.getTextWithPath(path).toPromise()
  }

  getNativeWindow() {
    return window
  }

  async getIndustryStatistic() {
    const path = `${
      environment.cpmBaseUrl
    }/industryStatistic?indexLevel=Market&indexLevel=Industry&indexLevel=Sector`
    return this.apiClient.getWithPath(path).toPromise()
  }

  async getSecurityList() {
    const path = `${environment.cpmBaseUrl}/securityList`
    return this.apiClient.getWithPath(path).toPromise()
  }

  async getEmployeeList() {
    const path = `${environment.cpmBaseUrl}/crm/employeeList`
    return this.apiClient.getWithPath(path).toPromise()
  }

  async getIndustryStatisticBySec(marketName, indexLevel, indexName) {
    const path = `${
      environment.cpmBaseUrl
    }/industryStatistic?marketName=${marketName}&indexLevel=${indexLevel}&indexName=${indexName}`

    return this.apiClient.getWithPath(path).toPromise()
  }

  async getSecurityFinancialStatistic(
    quarter,
    round,
    marketName,
    indexLevel,
    indexName
  ) {
    const path = `${
      environment.cpmBaseUrl
    }/securityFinancialStatistic?round=3&marketName=${marketName}&indexLevel=${indexLevel}&indexName=${indexName}`

    return this.apiClient.getWithPath(path).toPromise()
  }

  getSecurityFinancialStatisticBySecuritySymbol(securitySymbol: string) {
    securitySymbol = encodeURIComponent(securitySymbol)
    const path = `${
      environment.cpmBaseUrl
    }/securityFinancialStatistic/bySecuritySymbol?round=3&securitySymbol=${securitySymbol}`
    return this.apiClient.getWithPath(path).toPromise()
  }

  async getAdjustedFreefloatByRoundAndSecuritySymbol(
    round: Number,
    securitySymbol: string
  ) {
    securitySymbol = encodeURIComponent(securitySymbol)
    const path = `${
      environment.cpmBaseUrl
    }/adjustedFreefloat?round=${round}&securitySymbol=${securitySymbol}`
    return this.apiClient.getWithPath(path).toPromise()
  }

  async saveSectorProfitDataPdfFile(radioByView) {
    const path = `${
      environment.cpmBaseUrl
    }/savePdf/sectorProfitData?viewValue=${radioByView}`
    return this.apiClient.getTextWithPath(path).toPromise()
  }

  async saveExecutiveSummaryPdfFile(symbol) {
    const endcodeSymbol = encodeURIComponent(symbol)
    const path = `${
      environment.cpmBaseUrl
    }/savePdf/executiveSummary?symbol=${endcodeSymbol}`
    return this.apiClient.getTextWithPath(path).toPromise()
  }

  async saveboardShareholderPdfFile(symbol, freeFloat, majorShare) {
    const endcodeSymbol = encodeURIComponent(symbol)
    const path = `${
      environment.cpmBaseUrl
    }/savePdf/boardShareholder?symbol=${endcodeSymbol}&freeFloat=${freeFloat}&majorShare=${majorShare}`
    return this.apiClient.getTextWithPath(path).toPromise()
  }
  async saveAdditionalInfo(symbol) {
    const endcodeSymbol = encodeURIComponent(symbol)
    const path = `${
      environment.cpmBaseUrl
    }/savePdf/additionalInfo?symbol=${endcodeSymbol}`
    return this.apiClient.getTextWithPath(path).toPromise()
  }
  async saveSectorPopupData(
    radioByView,
    radioByFinancial,
    indexName,
    marketName,
    indexLevel
  ) {
    const path = `${
      environment.cpmBaseUrl
    }/savePdf/sectorPopupData?radioByView=${radioByView}&
      radioByFinancial=${radioByFinancial}&indexN=${indexName}&marketL=${marketName}&indexL=${indexLevel}`
    return this.apiClient.getTextWithPath(path).toPromise()
  }
  async saveCrmAeSummary(yearByteam, yearByIndividual) {
    const path = `${
      environment.cpmBaseUrl
    }/savePdf/crmaesummary?yearByTeam=${yearByteam}&yearByIndividual=${yearByIndividual}`
    return this.apiClient.getTextWithPath(path).toPromise()
  }

  async saveCrmOutputPdfFile(symbol, caseId) {
    const endcodeSymbol = encodeURIComponent(symbol)
    const path = `${
      environment.cpmBaseUrl
    }/savePdf/crmoutput?symbol=${endcodeSymbol}&caseId=${caseId}`
    return this.apiClient.getTextWithPath(path).toPromise()
  }

  getSecurityProfile(securitySymbol) {
    securitySymbol = encodeURIComponent(securitySymbol)
    const path = `${
      environment.cpmBaseUrl
    }/securityProfile?securitySymbol=${securitySymbol}`

    return this.apiClient
      .getWithPath(path)
      .toPromise<any>()
      .then(res => {
        this.securityProfile = res
        return Promise.resolve(res)
      })
  }

  async getSecurityProfileNew(securitySymbol) {
    if (isNullOrUndefined(securitySymbol) || securitySymbol.length < 1) {
      return Promise.reject('')
    }

    if (
      !!this.securityProfile &&
      this.securityProfile.securitySymbol === securitySymbol
    ) {
      return new Promise((resolve, reject) => {
        resolve(this.securityProfile)
      })
    }
    Promise.all([
      this.getSecurityProfile(securitySymbol),
      this.getIsAE(securitySymbol)
    ]).then(([securityProfile, isAE]) => {
      securityProfile['ae'] = isAE
      this.securityProfile = securityProfile
      this.store.setSecurityProfileResult(securityProfile)
    })
  }

  async getMajorShareholderAsOfDateList(securitySymbol) {
    securitySymbol = encodeURIComponent(securitySymbol)
    const path = `${
      environment.cpmBaseUrl
    }/majorShareholder/asOfDateList?securitySymbol=${securitySymbol}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  async getSecurityStatistic(securitySymbol) {
    securitySymbol = encodeURIComponent(securitySymbol)
    const path = `${
      environment.cpmBaseUrl
    }/securityStatistic?securitySymbol=${securitySymbol}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  async getMajorShareholder(securitySymbol, asOfDate) {
    securitySymbol = encodeURIComponent(securitySymbol)
    const path = `${
      environment.cpmBaseUrl
    }/majorShareholder?securitySymbol=${securitySymbol}&asOfDate=${asOfDate}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  async getSignPosting(sort, symbol) {
    symbol = encodeURIComponent(symbol)
    const path = `${
      environment.cpmBaseUrl
    }/signPosting?sort=${sort}&securitySymbol=${symbol}`
    return this.apiClient.getWithPath(path).toPromise()
  }
  async updateCompanyProfile(body) {
    const path = `${environment.cpmBaseUrl}/companyProfile`
    return this.apiClient.putWithPath(path, body).toPromise()
  }

  async getBODList(symbol) {
    symbol = encodeURIComponent(symbol)
    const path = `${environment.cpmBaseUrl}/bod?securitySymbol=${symbol}`
    return this.apiClient.getWithPath(path).toPromise()
  }

  async getAllSignPosting(symbol) {
    symbol = encodeURIComponent(symbol)
    const path = `${
      environment.cpmBaseUrl
    }/signPosting/all?securitySymbol=${symbol}&numberOfYear=5`
    return this.apiClient.getWithPath(path).toPromise()
  }

  async uploadFile(body) {
    const path = `${environment.cpmBaseUrl}/uploadFile`
    return this.apiClient.postWithPath(path, body).toPromise()
  }

  async getFreeFloatAsOfDate(symbol) {
    symbol = encodeURIComponent(symbol)
    const path = `${
      environment.cpmBaseUrl
    }/freefloat/asOfDateList?securitySymbol=${symbol}`
    return this.apiClient.getWithPath(path).toPromise()
  }

  async getFreeFloat(symbol, date) {
    symbol = encodeURIComponent(symbol)
    const path = `${
      environment.cpmBaseUrl
    }/freefloat?securitySymbol=${symbol}&asOfDate=${date}`
    return this.apiClient.getWithPath(path).toPromise()
  }

  async getForeignLimit(symbol) {
    symbol = encodeURIComponent(symbol)
    const path = `${
      environment.cpmBaseUrl
    }/foreignLimit?securitySymbol=${symbol}`
    return this.apiClient.getWithPath(path).toPromise()
  }

  async testDownloadLink(companyIdPsims) {
    companyIdPsims = encodeURIComponent(companyIdPsims)
    const path = `${
      environment.cpmBaseUrl
    }/download?type=revenue&id=${companyIdPsims}`
    return this.apiClient.getWithPath(path).toPromise()
  }

  async testDownloadBod(bodId) {
    const path = `${
      environment.cpmBaseUrl
    }/download?type=bodprofile&id=${bodId}`
    return this.apiClient.getBlobWithPath(path).toPromise()
  }

  getSecurityTradingByPeer(symbol, period, type) {
    const encodeSymbol = encodeURIComponent(symbol)
    const path = `${
      environment.cpmBaseUrl
    }/securityTrading/byPeer?securitySymbol=${encodeSymbol}&period=${period}&type=${type}`
    return this.apiClient.getWithPath(path).toPromise()
  }

  async getSecurityTrading(securitySymbol, period) {
    securitySymbol = encodeURIComponent(securitySymbol)
    const path = `${
      environment.cpmBaseUrl
    }/securityTrading?securitySymbol=${securitySymbol}&period=${period}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  async getPopupSecurityTrading(securitySymbol, nativeType, period) {
    securitySymbol = encodeURIComponent(securitySymbol)
    const path = `${
      environment.cpmBaseUrl
    }/securityTrading?securitySymbol=${securitySymbol}&nativeType=${nativeType}&period=${period}`
    return this.apiClient.getWithPath(path).toPromise()
  }

  async getSecurityTradingByInvestor(symbol, round) {
    symbol = encodeURIComponent(symbol)
    const path = `${
      environment.cpmBaseUrl
    }/securityTrading/byInvestorType?securitySymbol=${symbol}&round=${round}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  async getSecurityTradingByPeriod(securitySymbol, period) {
    securitySymbol = encodeURIComponent(securitySymbol)
    const path = `${
      environment.cpmBaseUrl
    }/securityTrading/byPeriod?securitySymbol=${securitySymbol}&period=${period}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  async getCrmCase(securitySymbol, type) {
    securitySymbol = encodeURIComponent(securitySymbol)
    const path = `${
      environment.cpmBaseUrl
    }/crm/caseList?type=${type}&securitySymbol=${securitySymbol}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  async getCaseStatusList() {
    const path = `${environment.cpmBaseUrl}/crm/caseStatusList`
    return this.apiClient.getWithPath(path).toPromise()
  }

  async getForwardingDepartment(securitySymbol) {
    securitySymbol = encodeURIComponent(securitySymbol)
    const path = `${
      environment.cpmBaseUrl
    }/crm/departmentList?securitySymbol=${securitySymbol}`

    return this.apiClient.getWithPath(path).toPromise()
  }

  async getMeetingObjective() {
    const path = `${environment.cpmBaseUrl}/crm/meetingObjectiveList`
    return this.apiClient.getWithPath(path).toPromise()
  }

  async getSignCurrent(securitySymbol) {
    securitySymbol = encodeURIComponent(securitySymbol)
    const path = `${
      environment.cpmBaseUrl
    }/signPosting/current?securitySymbol=${securitySymbol}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  async getFinancialAlertBySecuritySymbol(securitySymbol) {
    securitySymbol = encodeURIComponent(securitySymbol)
    const path = `${
      environment.cpmBaseUrl
    }/financialAlert/bySecuritySymbol?securitySymbol=${securitySymbol}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  async updateSecurityTradingByPeer(body) {
    const path = `${environment.cpmBaseUrl}/securityTrading/byPeer`
    return this.apiClient.putWithPath(path, body).toPromise()
  }

  async getForeignExposure(securitySymbol, round) {
    securitySymbol = encodeURIComponent(securitySymbol)
    const path = `${
      environment.cpmBaseUrl
    }/investment/foreignExposure?securitySymbol=${securitySymbol}&round=${round}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  async putCaseData(body) {
    const path = `${environment.cpmBaseUrl}/crm/case`
    return this.apiClient.putWithoutContentType(path, body).toPromise()
  }

  getCrmCaseById(id) {
    const path = `${environment.cpmBaseUrl}/crm/case?id=${id}`
    return this.apiClient.getWithPath(path)
  }
  async saveTradingPdfFile(symbol, period, type, pricePerType) {
    const endcodeSymbol = encodeURIComponent(symbol)
    const path = `${
      environment.cpmBaseUrl
    }/savePdf/trading?symbol=${endcodeSymbol}&period=${period}&type=${type}&pricePerType=${pricePerType}`
    return this.apiClient.getTextWithPath(path).toPromise()
  }

  async saveContactListedPdfFile(symbol) {
    symbol = encodeURIComponent(symbol)
    const path = `${
      environment.cpmBaseUrl
    }/savePdf/contact?symbol=${symbol}/true`
    return this.apiClient.getTextWithPath(path).toPromise()
  }

  async saveContactStaffPdfFile(symbol) {
    symbol = encodeURIComponent(symbol)
    const path = `${
      environment.cpmBaseUrl
    }/savePdf/contact?symbol=${symbol}/false`
    return this.apiClient.getTextWithPath(path).toPromise()
  }
  async saveFullFactSheetPdfFile(symbol, period) {
    symbol = encodeURIComponent(symbol)
    const path = `${
      environment.cpmBaseUrl
    }/savePdf/fullfactsheet?symbol=${symbol}&period=${period}`
    return this.apiClient.getTextWithPath(path).toPromise()
  }

  async getCompanyContactList(securitySymbol) {
    securitySymbol = encodeURIComponent(securitySymbol)
    const path = `${
      environment.cpmBaseUrl
    }/crm/contactList?securitySymbol=${securitySymbol}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  async getAEList(securitySymbol) {
    securitySymbol = encodeURIComponent(securitySymbol)
    const path = `${
      environment.cpmBaseUrl
    }/crm/AEList?securitySymbol=${securitySymbol}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }
  async getSummaryByTeam(year) {
    const path = `${environment.cpmBaseUrl}/crm/summaryByTeam?year=${year}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }
  async getSummaryByIndividual(year) {
    const path = `${
      environment.cpmBaseUrl
    }/crm/summaryByIndividual?year=${year}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  async getlistCrmCase() {
    // securitySymbol = encodeURIComponent(securitySymbol);
    const path = `${environment.cpmBaseUrl}/crm/caseList?type=pending`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  insertOrUpdateContract(mode, form) {
    const path = `${environment.cpmBaseUrl}/crm/contactProfile`
    switch (mode) {
      case 'I':
        return this.apiClient.putWithoutContentType(path, form)
      case 'U':
        return this.apiClient.putWithoutContentType(path, form)
      case 'D':
        return this.apiClient.putWithoutContentType(path, form)
      default:
        break
    }
    // return 'OK';
  }
  getRoleList() {
    const path = `${environment.cpmBaseUrl}/crm/roleList`
    return this.apiClient.getWithPath(path)
  }
  getContactProfile(id) {
    const path = `${environment.cpmBaseUrl}/crm/contactProfile?id=${id}`
    return this.apiClient.getWithPath(path)
  }
  async getParChange(securitySymbol) {
    securitySymbol = encodeURIComponent(securitySymbol)
    const path = `${
      environment.cpmBaseUrl
    }/corporateAction/parChange?securitySymbol=${securitySymbol}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }
  async getSummaryCorporateAction(securitySymbol, round) {
    securitySymbol = encodeURIComponent(securitySymbol)
    const path = `${
      environment.cpmBaseUrl
    }/corporateAction/summary?securitySymbol=${securitySymbol}&round=${round}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  async getDividend(securitySymbol, round) {
    securitySymbol = encodeURIComponent(securitySymbol)
    const path = `${
      environment.cpmBaseUrl
    }/corporateAction/dividend?securitySymbol=${securitySymbol}&round=${round}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  async getCapitalRaisedByTransaction(securitySymbol, round) {
    securitySymbol = encodeURIComponent(securitySymbol)
    const path = `${
      environment.cpmBaseUrl
    }/capitalRaised/byTransaction?securitySymbol=${securitySymbol}&round=${round}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  getCorporateActionOther?(symbol) {
    symbol = encodeURIComponent(symbol)
    const path = `${
      environment.cpmBaseUrl
    }/corporateAction/other?securitySymbol=${symbol}&round=5`

    return this.apiClient.getWithPath(path)
  }

  updateOtherCA(form) {
    const path = `${environment.cpmBaseUrl}/corporateAction/other`
    return this.apiClient.putWithoutContentType(path, form)
  }

  saveCorporatePdfFile(symbol) {
    symbol = encodeURIComponent(symbol)
    const path = `${environment.cpmBaseUrl}/savePdf/corporate?symbol=${symbol}`
    return this.apiClient.getTextWithPath(path).toPromise()
  }

  async getRevenueBySecuritySymbol(symbol, year) {
    symbol = encodeURIComponent(symbol)
    const path = `${
      environment.cpmBaseUrl
    }/revenue?securitySymbol=${symbol}&year=${year}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }
  async getRevenueItemList() {
    const path = `${environment.cpmBaseUrl}/revenueItemList`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  updateRevenue(form) {
    const path = `${environment.cpmBaseUrl}/revenue`
    return this.apiClient.putWithoutContentType(path, form)
  }

  getCompanyStructure(symbol) {
    symbol = encodeURIComponent(symbol)
    const path = `${
      environment.cpmBaseUrl
    }/companyStructure?securitySymbol=${symbol}`
    return this.apiClient.getWithPath(path)
  }

  updateCompanyStructure(form) {
    const path = `${environment.cpmBaseUrl}/companyStructure`
    return this.apiClient.putWithoutContentType(path, form)
  }

  getFactsheetFlagBySymbol(symbol) {
    symbol = encodeURIComponent(symbol)
    const path = `${
      environment.cpmBaseUrl
    }/factsheetFlag?securitySymbol=${symbol}`
    return this.apiClient.getWithPath(path)
  }

  public getAuthorities() {
    const path = `${environment.cpmBaseUrl}/me`
    return this.apiClient.getWithPath(path)
  }

  getAllAEList() {
    const path = `${environment.cpmBaseUrl}/crm/allAEList`
    return this.apiClient.getWithPath(path).toPromise()
  }

  getIsAE(symbol) {
    symbol = encodeURIComponent(symbol)
    const path = `${environment.cpmBaseUrl}/isAE?securitySymbol=${symbol}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return res
      })
  }

  getRevenueContribution(symbol, round) {
    symbol = encodeURIComponent(symbol)
    const path = `${
      environment.cpmBaseUrl
    }/SETRevenueContribution?round=${round}&securitySymbol=${symbol}`
    return this.apiClient
      .getWithPath(path)
      .toPromise()
      .then(res => {
        return Promise.resolve(res)
      })
  }

  updateAEProfile(putData) {
    const path = `${environment.cpmBaseUrl}/crm/AEProfile?id=${
      putData.id
    }&securityIdPsims=${putData.securityIdPsims}`
    return this.apiClient.putWithPath(path, {}).toPromise()
  }

  deleteAEProfile(id) {
    const path = `${environment.cpmBaseUrl}/crm/AEProfile?Id=${id}`
    return this.apiClient.deleteWithPath(path).toPromise()
  }

  downloadFile(url) {
    return this.apiClient
      .getBlobWithPath(url)
      .toPromise()
      .then(res => {
        FileSaver.saveAs(res)
      })
  }

  viewFileInIFrame(url) {
    return this.apiClient
      .getBlobWithPath(url)
      .toPromise()
      .then(res => {
        return URL.createObjectURL(res)
      })
  }

  validateParams(...args): Boolean {
    return !(args.filter(x => isNullOrUndefined(x)).length > 0)
  }
  multiFilter(array, filters) {
    const filterKeys = Object.keys(filters)
    return array.filter(item => {
      // tslint:disable-next-line:no-bitwise
      return filterKeys.every(key => !!~filters[key].indexOf(item[key]))
    })
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/service/cpm.service.ts